import React, { useEffect, useState } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/sectionTitle/SectionTitle';
import PostTwo from '../../components/post/PostTwo';
import PostData from '../../data/blog/PostData.json';
import { SERVER_URL } from '../../utils/fetch';

const HomeOneBlog = () => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        const getBlogs = async () => {
            const response = await fetch(`${SERVER_URL}/api/blog`).then(res => res.json())
            if (response.success) {
                let blogs = response.data;
                blogs = blogs.map((item, index) => ({
                    "id": index,
                    "title": item.title,
                    "image": `${SERVER_URL}/public/${item.file_name}`,
                    "date": item.date,
                    "description": item.description,
                    "content": item.content,
                    "categories": ["Business", "Education"],
                    "tags": item.tags,
                    "details": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."
                }))
                blogs = blogs.sort((a,b) => a.title > b.title);
                setItems(blogs)
            }
        }
        getBlogs();
    }, [])


    return (
        <div className="edu-blog-area eduvibe-home-one-blog edu-section-gap bg-image">
            <div className="container eduvibe-animated-shape">
                <div className="row g-5 align-items-center">
                    <div className="col-lg-6">
                        <SectionTitle
                            classes = "text-start"
                            slogan = "BLog & News"
                            title = "Trending on Our Blogs"
                        />
                    </div>
                    <div className="col-lg-6">
                        <div className="read-more-btn text-end">
                            <Link className="edu-btn" to="/blog">Read More Blogs<i className="icon-arrow-right-line-right"></i></Link>
                        </div>
                    </div>
                </div>
                <div className="row g-5 mt--30">
                    { 
                        items.slice( 0, 2 ).map((item) => (
                            <ScrollAnimation 
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}
                                className="col-lg-6 col-sm-6 col-12"
                                key={ item.id } 
                            >
                                <PostTwo data={item} bgWhite="enable" />
                            </ScrollAnimation>
                        ) )
                    }
                </div>
                <div className="shape-dot-wrapper shape-wrapper d-xl-block d-none">
                    <div className="shape-image shape-image-1">
                        <img src="/images/shapes/shape-04-02.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape-image shape-image-2">
                        <img src="/images/shapes/shape-15-02.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape-image shape-image-3">
                        <img src="/images/shapes/shape-13-03.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape-image shape-image-4">
                        <img src="/images/shapes/shape-17.png" alt="Shape Thumb" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeOneBlog;